

























































































import {
  defineComponent,
  ref,
  useFetch,
  useRoute,
  computed,
  onUnmounted,
} from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import ProductLoadItem from "~/components/SkeletonLoader/ProductLoadItem.vue";
import { useFlashSale } from "~/composables";
import { useConfigStore } from "~/stores/extensionApi";

export default defineComponent({
  name: "FlashDeal",
  components: {
    LazyComponent,
    SkeletonLoader,
    ProductLoadItem,
    CategoryProductGrid: () =>
      import(
        "~/modules/catalog/category/components/views/CategoryProductGrid.vue"
      ),
  },

  setup() {
    const route = useRoute();
    const id = computed(() => route.value?.params?.id);
    const configStore = useConfigStore();
    const { load: loadFlashSale, loading } = useFlashSale();

    const flashDealImage = computed(
      () => configStore.getFlashDealConfig?.image_deal_list
    );
    const flashDealImageMobile = computed(
      () => configStore.getFlashDealMobile?.image_deal_list
    );
    const products = ref<any[]>([]);
    const days = ref(null);
    const hours = ref(null);
    const minutes = ref(null);
    const seconds = ref(null);
    const currentPage = ref(0);
    const isShowproduct = ref(true);

    useFetch(async () => {
      const result = await loadFlashSale();
      products.value =
        result && result.length > 0 ? changeDataFlashSale(result) : [];
      if (products.value.length < 16) {
        isShowproduct.value = false;
      }
      if (products.value && products.value.length > 0) {
        countDownTime();
      }
    });

    const isLoadingMore = ref(false);
    const loadMoreProducts = async () => {
      isLoadingMore.value = true;
      currentPage.value += 1;
      const result = await loadFlashSale({ offset: currentPage.value * 16 });

      const newProducts =
        result && result.length > 0 ? changeDataFlashSale(result) : [];
      if (newProducts.length < 16) {
        isShowproduct.value = false;
      }
      products.value = [...products.value, ...newProducts];
      isLoadingMore.value = false;
    };

    const getTimeLeft = (until: number) => {
      return {
        seconds: Math.floor(until % 60),
        minutes: Math.floor(until / 60) % 60,
        hours: Math.floor(until / (60 * 60)) % 24,
        days: Math.floor(until / (60 * 60 * 24)),
      };
    };

    const interval = ref(null);

    const countDownTime = () => {
      const time =
        products.value?.length > 0 ? products.value[0].deals[0]?.date_to : 0;
      if (time != 0) {
        const result =
          new Date(time?.replace(/-/g, "/")).getTime() - new Date().getTime();
        let times = result / 1000;
        interval.value = setInterval(() => {
          times = times - 1;
          const {
            days: d,
            hours: h,
            minutes: m,
            seconds: s,
          } = getTimeLeft(times);
          days.value = d;
          hours.value = h > 9 ? h.toString() : `0${h}`;
          minutes.value = m > 9 ? m.toString() : `0${m}`;
          seconds.value = s > 9 ? s.toString() : `0${s}`;
        }, 1000);
      } else {
        if (interval.value) {
          clearInterval(interval.value);
        }
      }
    };

    onUnmounted(() => {
      if (interval.value) {
        clearInterval(interval.value);
      }
    });

    const changeDataFlashSale = (data) => {
      if (data && data.length > 0) {
        let flashSaleOff = [];
        let flashSaleHot = [];
        data.map((item) => {
          if (item.deal_qty > item.sale_qty && item.sale_qty > 0) {
            flashSaleHot.push(item);
          } else {
            flashSaleOff.push(item);
          }
        });

        return [...checkProductSale(flashSaleHot), ...flashSaleOff];
      }
    };

    const checkProductSale = (dataProduct) => {
      return dataProduct.sort(
        (a, b) =>
          (a.deal_qty - a.sale_qty) / a.deal_qty -
          (b.deal_qty - b.sale_qty) / b.deal_qty
      );
    };

    return {
      products,
      days,
      hours,
      minutes,
      seconds,
      loading,
      flashDealImage,
      flashDealImageMobile,
      isLoadingMore,
      loadMoreProducts,
      isShowproduct,
    };
  },
});
